module.exports = __webpack_public_path__ + "static/media/eeuu.27414395.svg";